import { useState, useEffect } from "react";
import { buscarPeriodoUsuarioByIdService } from "../../../services/buscarPeriodoUsuarioByIdService";
import { buscarCotaUsuarioByPEUId } from "../../../services/buscarCotaUsuarioByPEUId copy";

export const useBuscarPeu = (
  periodoUsuarioId: number,
  isModalOpen: boolean
) => {
  const [peu, setPeu] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      if (!isModalOpen || !periodoUsuarioId) {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const data = await buscarCotaUsuarioByPEUId(periodoUsuarioId);
        setPeu(data);
      } catch (error) {
        console.error("Erro ao buscar período:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, [isModalOpen, periodoUsuarioId]);

  return { peu, isLoading };
};
